// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GCs6","fullView":"styles_fullView__1NwFv"};